import { NavigationProvider } from "@platform/navigation-control";
import { Link, useNavigate } from "react-router";

import type { ReactNode } from "react";

// Every path the app routes itself; the design system's links leave the app for others.
const APP_ROUTES = ["/", "/cases", "/review", "/groups", "/suites"];

/** Lets design-system links and the navigation bar route inside the app. */
export const AppNavigationProvider = ({
  children,
}: {
  readonly children: ReactNode;
}): ReactNode => {
  const navigate = useNavigate();

  return (
    <NavigationProvider
      routes={APP_ROUTES}
      RouterLink={Link}
      navigate={(path) => void navigate(path)}
    >
      {children}
    </NavigationProvider>
  );
};
